import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { TTM_DATA_SEND_INTERVAL } from 'constants/config'
import useInterval from 'hooks/useInterval/useInterval'
import { ACTIVE_SPEAKER } from 'services/webSockets/talktimeMonitor/constants'
import { dispatchSendSocketMessage } from 'store/dispatcher'
import {
    _IsMaster,
    _IsSpeaking,
    getParticipantInfo,
    _dominantSpeaker,
} from 'store/selectors/Room'

const useDataSender = ({ userId }) => {
    const speakerId = useRef()
    const dominantSpeakerId = useSelector(_dominantSpeaker)
    const dominantSpeakerInfo = useSelector(state =>
        getParticipantInfo(state, dominantSpeakerId)
    )

    const isDominantSpeakerAudioEnabled = dominantSpeakerInfo?.isAudioEnabled

    const isLocalUserSpeaking = useSelector(_IsSpeaking)
    const isMaster = useSelector(_IsMaster)

    useEffect(() => {
        if (!isMaster) return

        speakerId.current = isLocalUserSpeaking
            ? userId
            : isDominantSpeakerAudioEnabled
            ? dominantSpeakerId
            : null
    }, [
        isLocalUserSpeaking,
        dominantSpeakerId,
        isDominantSpeakerAudioEnabled,
        isMaster,
        userId,
    ])

    useInterval(
        () => {
            const msg = {
                action: ACTIVE_SPEAKER,
                user_id: speakerId.current,
            }

            dispatchSendSocketMessage(msg)
        },
        !isMaster ? null : TTM_DATA_SEND_INTERVAL
    )
}

export default useDataSender
